"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = LaborLawPosters;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const react_i18next_1 = require("react-i18next");
const UserContext_1 = require("../contexts/UserContext");
const Screen_1 = __importDefault(require("../components/Screen"));
const cancelable_promise_1 = require("cancelable-promise");
const Risk_1 = __importDefault(require("../api/Risk"));
const Loading_1 = __importDefault(require("../components/Loading"));
const react_native_1 = require("react-native");
function LaborLawPosters(props) {
    const { t } = (0, react_i18next_1.useTranslation)();
    const userContext = react_1.default.useContext(UserContext_1.UserContext);
    const promise = react_1.default.useRef(null);
    const [loading, setLoading] = react_1.default.useState(true);
    const [url, setUrl] = react_1.default.useState(null);
    const refresh = () => {
        promise.current?.cancel();
        setLoading(true);
        promise.current = (0, cancelable_promise_1.cancelable)(userContext.getToken().then(token => Risk_1.default.getLaborLawPosterUrl(token))).then(data => {
            if (data.url)
                setUrl(data.url);
        }).catch((e) => {
            console.error(e);
        }).finally(() => {
            setLoading(false);
        });
    };
    react_1.default.useEffect(() => {
        refresh();
        return () => { promise.current?.cancel(); };
    }, []);
    return ((0, jsx_runtime_1.jsx)(Screen_1.default, { fullScreenContent: true, scrollEnabled: false, containerStyle: { flex: 1 }, noScrollStyle: { flex: 1 }, scrollStyle: { flex: 1 }, children: (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { flex: 1, display: 'flex', minHeight: 0 }, children: loading
                &&
                    (0, jsx_runtime_1.jsx)(Loading_1.default, { retryable: false, loading: loading })
                ||
                    (0, jsx_runtime_1.jsx)("iframe", { src: url, title: t('common:appmenus.laborLawPosters'), style: { flex: 1, width: '100%', height: '100%', border: 'none' } }) }) }));
}
;
